import { Contract, utils } from "ethers";
import { ERC20 } from "../abi/ERC20";
import { web3ReadOnlyInstance } from "../factory/web3Instance";

export const createContract = (abi: any, library: any, address: string) => {
  if (!abi)
    console.warn("Creating an ERC20 contract as abi has not been provided");
  if (!library || !address) {
    console.warn(
      "Please provide an address and library, otherwise transaction will fail"
    );
    return;
  }

  return new Contract(
    address,
    new utils.Interface(abi || ERC20),
    library.getSigner()
  );
};

export const createReadOnlyContract = (
  chainId: number,
  abi: Object,
  address: string
) => {
  const web3 = web3ReadOnlyInstance.getInstance(chainId);
  const contract = new web3.eth.Contract(abi, address);

  return contract;
};
